import React from 'react';
import PropTypes from 'prop-types';
import { Glyphicon, Button, Alert, Table } from 'react-bootstrap';

export class TemplateJsonPanel extends React.Component {

    
    constructor(props) {
        super(props);        
        this.onDownloadLog = this.onDownloadLog.bind(this);
    }
    renderPanel(item, bsStyle){         
        return <Alert bsStyle={bsStyle}>
                 {item.value} 
        </Alert>;
    }

    renderImages(item){           
         let resolution = 1024/item.items.length;         
         return <Table responsive>
                <tr>
                    {item.items.map((value, index) => { 
                        var src = "data:image/png;base64," +  value.value;  
                        var ratio = resolution/value.xsize;                 
                        return <td>
                            
                            <img height={value.ysize * ratio} width={value.xsize * ratio} src={src} alt="" />                            
                             <br />
                            <span class='summary_datacollection_parameter'>{value.title}</span>

                        </td>

                    })} 

                </tr>
        </Table>;
       
    }

    renderImage(item){                       
         let ratio = item.xsize/1024;
         var src = "data:image/png;base64," +  item.value;  
         return <div>
                    <img height={item.ysize * ratio} width={item.xsize * ratio} src={src} alt="" />
                    <br />
                    <span class='summary_datacollection_parameter'>{item.title}</span>
         </div>

    }

    renderTable(item){                                
       
         return <Table responsive striped bordered condensed hover>
            <th style={{backgroundColor:'#3892d3',color:'white',fontSize:'14px'}} colSpan={item.columns.length}>{item.title}</th>
            <tbody>
                <tr>
                    {item.columns.map((value, index) => {                         
                        return <th>{value}</th>

                    })}
                 </tr> 
                 {item.data.map((value, index) => {                      
                        return <tr>
                             {value.map((column, indexColumns) => {                                  
                                 return <td>{column}</td>
                             })}
                        </tr>;
                    })}

            </tbody>                  
         </Table>

    }

    onDownloadLog(e){           
        const element = document.createElement("a");
        const file = new Blob([e.target.value], {type: 'text/plain'});
        element.href = URL.createObjectURL(file);
        element.download = "myFile.txt";
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
    }
    renderLogFile(item){                               
         return <Button value={item.logText} onClick={this.onDownloadLog}>
                    <Glyphicon glyph="download-alt" ></Glyphicon> {item.linkText}
            </Button>;

    }

    renderItem(item){
        switch(item.type) {
            case "title":
                return <h1>{item.value}</h1>;  
            case "info":
                return this.renderPanel(item, "info");  
            case "warning":
                return this.renderPanel(item, "warning");                  
            case "images":
                 return this.renderImages(item);
            case "image":
                 return this.renderImage(item);
            case "table":
                 return this.renderTable(item);
            case "logFile":
                 return this.renderLogFile(item);
            default:
                return item.type + " Not implement yet";
        }                   
    }

    render() {    
       if (this.props.type == null){
           return null;
       }
       
       return <div style={{margin:'50px'}}>
            {this.props.items.map((value, index) => { 
                return this.renderItem(value);

            })}              
       </div>;
    }
}

TemplateJsonPanel.propTypes = {  
  title: PropTypes.string,
  type: PropTypes.string,
  items: PropTypes.array
  
};

export default TemplateJsonPanel;



// WEBPACK FOOTER //
// ./src/components/TemplateJsonPanel.js